import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bda6362&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6bda6362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda6362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bda6362')) {
      api.createRecord('6bda6362', component.options)
    } else {
      api.reload('6bda6362', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bda6362&scoped=true&", function () {
      api.rerender('6bda6362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/article/index.vue"
export default component.exports